export default __webpack_public_path__ + "static/media/javascript.081325c6.svg";